define('views/modules/calendar/calendar/summary/summary-tables/summary-rows',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'moment',
    // events
    // Collections

    // views
    // Templates
    'text!templates/modules/calendar/calendar/summary/summary-tables/summary-rows.html',
], function(
    // libs
    _, Backbone, Mustache, U, moment,
    // events
    // Collections and models

    // views
    // templates
    TSummaryRows
) {

    var VSummaryRows = Backbone.View.extend({
        template: TSummaryRows,
        events: {

        },

        regions: {
            root: "tbody.summary-rows"
        },

        initialize: function(opt) {
            this.options = opt || {};
            this.options.rows = this.options.rows.toJSON();
        },

        render: function() {

            // Render HTML template
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));

            // caching element into this.zone
            this.generateZones();

            return this;
        },

    });

    return VSummaryRows;

});

